<div class="community-search container-xl py-3" *transloco="let t">
  <header class="d-flex align-items-center justify-content-between flex-wrap gap-2 mb-3">
    <h1 class="h3 mb-0">🔎 {{ t('community.search.title') }}</h1>
    <a class="btn btn-outline-secondary btn-sm" [routerLink]="communityLink()">← {{ t('community.thread.back') }}</a>
  </header>

  <form class="d-flex gap-2 mb-3" (ngSubmit)="submit()">
    <input type="search" class="form-control" name="q" [placeholder]="t('community.search.placeholder')" [(ngModel)]="query" />
    <button type="submit" class="btn btn-primary" [disabled]="!query.trim()">{{ t('community.search.action') }}</button>
  </form>

  <ul class="nav nav-tabs mb-3">
    @for (ty of types; track ty) {
      <li class="nav-item">
        <button type="button" class="nav-link" [class.active]="type() === ty" (click)="selectType(ty)">
          {{ t('community.search.type.' + ty) }}
        </button>
      </li>
    }
  </ul>

  @if (tooShort()) {
    <div class="alert alert-warning">{{ t('community.errors.community_query_too_short') }}</div>
  } @else if (error(); as key) {
    <div class="alert alert-danger">{{ t(key) }}</div>
  } @else if (loading()) {
    <div class="text-center py-4"><div class="spinner-border" role="status"></div></div>
  } @else if (result(); as res) {
    @if (threadHits().length === 0 && postHits().length === 0 && peopleHits().length === 0) {
      <p class="text-muted py-4 text-center">{{ t('community.search.empty') }}</p>
    }

    @if (res.threads) {
      <section class="mb-4">
        <h2 class="h6">{{ t('community.search.threads_title', { count: res.threads.total_count }) }}</h2>
        <ul class="list-group">
          @for (hit of threadHits(); track hit.id) {
            <a class="list-group-item list-group-item-action" [routerLink]="threadLink(hit.id)">
              <div class="d-flex justify-content-between gap-2">
                <strong>{{ hit.title }}</strong>
                @if (hit.channel) { <small class="text-muted"># {{ hit.channel.name }}</small> }
              </div>
              <p class="mb-0 small text-muted">{{ hit.excerpt }}</p>
            </a>
          } @empty {
            <li class="list-group-item text-muted small">{{ t('community.search.no_threads') }}</li>
          }
        </ul>
      </section>
    }

    @if (res.posts) {
      <section class="mb-4">
        <h2 class="h6">{{ t('community.search.posts_title', { count: res.posts.total_count }) }}</h2>
        <ul class="list-group">
          @for (hit of postHits(); track hit.id) {
            <a class="list-group-item list-group-item-action" [routerLink]="threadLink(hit.thread_id)">
              <div class="d-flex justify-content-between gap-2">
                <span>{{ hit.thread_title }}</span>
                <small class="text-muted"># {{ hit.channel.name }}</small>
              </div>
              <p class="mb-0 small text-muted">{{ hit.excerpt }}</p>
            </a>
          } @empty {
            <li class="list-group-item text-muted small">{{ t('community.search.no_posts') }}</li>
          }
        </ul>
      </section>
    }

    @if (res.people) {
      <section class="mb-4">
        <h2 class="h6">{{ t('community.search.people_title', { count: peopleHits().length }) }}</h2>
        <ul class="list-group">
          @for (u of peopleHits(); track u.id) {
            <a class="list-group-item list-group-item-action d-flex align-items-center gap-2" [routerLink]="memberLink(u.id)">
              <app-community-avatar [user]="u" [size]="32" />
              <span>{{ u.display_name }}</span>
              <app-community-badges [badges]="u.badges" />
            </a>
          } @empty {
            <li class="list-group-item text-muted small">{{ t('community.search.no_people') }}</li>
          }
        </ul>
      </section>
    }

    @if ((type() === 'threads' || type() === 'posts') && totalPages() > 1) {
      <nav class="d-flex gap-2 justify-content-center mt-3">
        <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() <= 1" (click)="goToPage(page() - 1)">‹</button>
        <span class="align-self-center small text-muted">{{ page() }} / {{ totalPages() }}</span>
        <button type="button" class="btn btn-sm btn-outline-secondary" [disabled]="page() >= totalPages()" (click)="goToPage(page() + 1)">›</button>
      </nav>
    }
  } @else {
    <p class="text-muted py-4 text-center">{{ t('community.search.hint') }}</p>
  }
</div>
